import React from "react";
import ReactDOM from "react-dom";
import { showToast } from "@tarojs/taro";
import ToastComponent, { ToastProps } from "./Toast";
import "./index.scss";

async function Toast(
  message: string | number,
  duration?: number
): Promise<void>;
async function Toast(props: ToastProps): Promise<void>;
async function Toast(
  arg: string | number | ToastProps,
  ...rest
): Promise<void> {
  let defalutParam = {
    title: "",
    duration: 3000,
    mask: true,
  };
  if (typeof arg === "string" || typeof arg === "number") {
    defalutParam.title = `${arg}`;
    if (rest.length) {
      defalutParam.duration = rest[0];
    }
  } else {
    defalutParam = {
      ...defalutParam,
      ...arg,
    };
  }
  return new Promise(resolve => {
    if (process.env.TARO_ENV === "h5") {
      const div = document.createElement("div");

      const timer = setTimeout(() => {
        ReactDOM.unmountComponentAtNode(div);
        clearTimeout(timer);
        resolve();
      }, defalutParam.duration);
      const { title, ...other } = defalutParam;
      ReactDOM.render(<ToastComponent title={title} {...other} />, div);
    } else {
      showToast({
        icon: "none",
        ...defalutParam,
      }).then(res => {
        if (res.errMsg === "showToast:ok") {
          const timer = setTimeout(() => {
            clearTimeout(timer);
            resolve();
          }, defalutParam.duration);
        }
      });
    }
  });
}

export default Toast;
